import { render } from "./Section3.vue?vue&type=template&id=55c43193&scoped=true"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"

import "./Section3.vue?vue&type=style&index=0&id=55c43193&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c43193"]])

export default __exports__